import { Component, OnInit } from '@angular/core';
import { ServerService } from '../../service/server/server.service';
import { MessageService } from '../../service/message/message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-menu-manage-sms',
  templateUrl: './menu-manage-sms.component.html',
  styleUrls: ['./menu-manage-sms.component.scss']
})
export class MenuManageSmsComponent implements OnInit {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public user_id!: number;
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  constructor(
    public serverService: ServerService,
    public messageService: MessageService,
    public matSnackBar: MatSnackBar,
  ) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
  }
  ngOnInit(): void {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.remind_sms();
  }
  remind_sms() {
    var obj = {
      'address': 6390
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['send_sms'] == 0 && res['time'] > '08:00:00') {
            this.get_list_users_for_send_sms(3, 'reminder');
            this.get_list_users_for_send_sms(7, 'reminder');
            this.get_list_users_for_send_sms(0, 'reminder2');
            this.insert_reminder_log();
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_list_users_for_send_sms(number_day: number, reminder: string) {
    var obj = {
      'address': 6315,
      'number_day': number_day
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.send_sms_expire(res['result'][i].user_sex_title + " " + res['result'][i].user_title, res['result'][i].user_cellphone, number_day, reminder);
          }//end for
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  send_sms_expire(user_store: string, cellphone: number, number_day: any, reminder: string): any {
    if (number_day == 0) number_day = 'امروز';
    var obj = {
      'address': 6515,
      'cellphone': cellphone,
      'number_day': number_day,
      'user_store': user_store,
      'reminder': reminder
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
      })
  }
  insert_reminder_log() {
    var obj = {
      'address': 6316,
      'user_id': this.user_id
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
        }//end if
      }
    )
  }
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
}
